/**
 * Founding Market Badge Component (Issue #1318)
 *
 * Displays a distinctive badge for founding markets (early-adopter fairs).
 * Visually distinct from the featured fair badge.
 */

import React from 'react';

interface FoundingMarketBadgeProps {
  /** CSS classes for custom styling */
  className?: string;
  /** Size variant */
  size?: 'small' | 'medium' | 'large';
}

/**
 * Badge component to display founding market status
 */
const FoundingMarketBadge: React.FC<FoundingMarketBadgeProps> = ({
  className = '',
  size = 'medium'
}) => {
  // Size classes
  const sizeClasses = {
    small: 'text-xs px-2 py-0.5',
    medium: 'text-sm px-2.5 py-1',
    large: 'text-base px-3 py-1.5'
  };

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full bg-amber-100 text-amber-800 font-semibold border border-amber-300 ${sizeClasses[size]} ${className}`}
      title="Founding Market - An early-adopter market that helped establish the platform"
      aria-label="Founding Market Badge"
    >
      <svg
        className="w-4 h-4"
        fill="currentColor"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
      </svg>
      <span>Founding Market</span>
    </span>
  );
};

export default FoundingMarketBadge;
